/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   All the origin variable should be defined here
 *                ref: https://docs.google.com/spreadsheets/d/1hLSFXWYZkAtB-vSHTD02JPprA1YfbAVi4hsB7pTLLGE/edit#gid=0
 *                see also: https://docs.google.com/spreadsheets/d/1umbHY6dmJkOgxKf95HTbFPNYrMaF0TlLPyaknBpQpOg/edit#gid=533489687
 */

export const Origin = {
  /* ------------------------------------Call----------------------------------------------------- */
  AUTO: 'auto',
  /* ----------------------------------------Email---------------------------------------- */
  FROM_EMAIL: 'ae',
  ADDR_FROM_EMAIL: 'ad-ae',
  /* ----------------------------------------Detail---------------------------------------- */
  // Full detail sticky inline messaging form
  DETAIL_INLINE: 'cb-il',
  ADDR_DETAIL_INLINE: 'ad-cb-il',
  // the message button in the top right rail of the new (2023) detail page
  DETAIL_TOP_RIGHT_RAIL: 'cb-detail',
  ADDR_DETAIL_TOP_RIGHT_RAIL: 'ad-cb-detail',
  // the tour buttons in the top right rail of the new (2023) detail page
  DETAIL_TOP_RIGHT_TOUR: 'cb-tour',
  ADDR_DETAIL_TOP_RIGHT_TOUR: 'ad-cb-tour',
  // in the sticky horizontal nav (top right)
  DETAIL_NAV_STICKY: 'cb-nav-sticky',
  ADDR_DETAIL_NAV_STICKY: 'ad-cb-nav-sticky',
  // in the sticky horizontal nav (top right)
  DETAIL_NAV_STICKY_TOUR: 'cb-nav-sticky-tour',
  ADDR_DETAIL_NAV_STICKY_TOUR: 'ad-cb-nav-sticky-tour',
  DETAIL_INLINE_BOTTOM: 'cb-b',
  ADDR_DETAIL_INLINE_BOTTOM: 'ad-cb-b',
  DETAIL_INLINE_BUBBLE: 'cb-bu-il',
  // Mobile Inline CTA
  // Full detail mobile fixed bottom bar
  DETAIL_MOBILE_BOTTOM: 'm.cb-bottom',
  ADDR_DETAIL_MOBILE_BOTTOM: 'ad-m.cb-bottom',
  // Full-width tour request section (bottom half of new detail page)
  DETAIL_BOTTOM_TOUR: 'cb-bottom-tour',
  // Mobile Sticky Bar
  DETAIL_MOBILE_STICKY: 'm.cb-sticky',
  ADDR_DETAIL_MOBILE_STICKY: 'ad-m.cb-sticky',
  DETAIL_MOBILE_STICKY_TOUR: 'm.cb-sticky-tour',
  ADDR_DETAIL_MOBILE_STICKY_TOUR: 'ad-m.cb-sticky-tour',
  // Full detail mobile fixed bottom bar schedule a tour
  DETAIL_MOBILE_BOTTOM_TOUR: 'm.cb-a-tour',
  // Full detail page inactive listing item
  DETAIL_INACTIVE: 'w-s',
  // Detail multi message related properties
  DETAIL_MM_RELATED_PROPERTIES: 'detail-mm-rp',
  ADDR_DETAIL_MM_RELATED_PROPERTIES: 'ad-detail-mm-rp', // origin used for address-on-building detail page
  ADDRESS_MM_RELATED_PROPERTIES: 'address-mm-rp',
  // Detail multi message nearby properties
  DETAIL_DESKTOP_MM_NEARBY_PROPERTIES: 'detail-mm-np',
  ADDR_DETAIL_DESKTOP_MM_NEARBY_PROPERTIES: 'ad-detail-mm-np',
  DETAIL_MOBILE_MM_NEARBY_PROPERTIES: 'm.detail-mm-np',

  // Detail agent box
  DETAIL_AGENT_BOX: 'cb-ag',
  ADDR_DETAIL_AGENT_BOX: 'ad-cb-ag',
  MOBILE_DETAIL_AGENT_BOX: 'm.cb-ag',
  // Listing
  BUILDING: 'building',
  LISTING: 'listing',
  // Equal CTA
  ECTA_MESSAGE_SUFFIX: '-ecta-msg',
  ECTA_TOUR_SUFFIX: '-ecta-tour',
  ECTA_APPLY_SUFFIX: '-ecta-apply',
  // Detail Highly Mesaged
  // Full detail page inactive listing item
  DETAIL_HIGHLY_MESSAGED: 'cb-hm',
  DETAIL_QUESTION: 'detail-question',
  ADDR_DETAIL_QUESTION: 'ad-detail-question',
  // Detail resident insights
  DETAIL_RESIDENT_INSIGHTS: 'cb-ri',
  MOBILE_DETAIL_RESIDENT_INSIGHTS: 'm.cb-ri',
  /* ----------------------------------------Carousel---------------------------------------- */
  // Lightbox Carousel final slide (came from listing/building page)
  CAROUSEL_FROM_DETAIL: 'cr-detail',
  /* -----------------------------------------Alert---------------------------------------- */
  ADDRESS_PAGE_INLINE_ALERT: 'pa-inline-alert',
  ADDR_ADDRESS_PAGE_INLINE_ALERT: 'ad-pa-inline-alert',
  MAP: 'map',
  LISTABLES: 'list',
  DETAIL_MIDDLE_SAVE_SEARCH: 'detail.m',
  DETAIL_BOTTOM_SAVE_SEARCH: 'detail.b',
  DETAIL_TOP_SAVE_SEARCH: 'detail.t',
  ADDR_DETAIL_TOP_SAVE_SEARCH: 'ad-detail.t',
  DETAIL_INLINE_MODULE: 'detail-inline-module',
  ADDR_DETAIL_INLINE_MODULE: 'ad-detail-inline-module',
  /* ------------------------------Affordability Calculator------------------------------------ */
  AFFORDABILITY_CALCULATOR: 'ac',
  /* ---------------------Rent Research / Programmatic Rent Report----------------------------- */
  RENT_RESEARCH: 'rr',
  RENT_RESEARCH_MOBILE: 'm.rr',
  RENT_RESEARCH_TOUR: 'rr-tour',
  RENT_RESEARCH_TOUR_MOBILE: 'm.rr-tour',
  /* ----------------------------------Similar Listings---------------------------------------- */
  // similar listings full detail bottom
  SIMILAR: 'wb-s',

  // similar listings full detail bottom schedule a tour
  SIMILAR_TOUR: 'wb-s-tour',
  MONETIZED_SIMILAR: 'wb-s-m',
  /* -------------------------------------Floor plan Viewer----------------------------------- */
  FLOORPLAN: 'fp',
  FLOORPLAN_CARD: 'fp',
  FLOORPLANS_UNIT_TOUR: 'fp-bd-unit-tour',
  FLOORPLANS_MODAL_UNIT_TOUR: 'fp-bd-modal-unit-tour',
  FLOORPLANS_MODAL_TOP: 'fp-bd-modal-top',
  ADDR_FLOORPLANS_MODAL_TOP: 'ad-fp-bd-modal-top',
  FLOORPLANS_MODAL_UNIT_TOP: 'fp-bd-modal-unit-top',
  ADDR_FLOORPLANS_MODAL_UNIT_TOP: 'ad-fp-bd-modal-unit-top',
  MOBILE_FLOORPLAN: 'm.fp',
  MODAL_SUFFIX: '-modal',
  /* ----------------------------------Select Landing City Page----------------------------------- */
  SELECT_LANDING_MESSAGE_MODAL: 'vnewl',
  SELECT_LANDING_FORM_ALERT: 'vip-new.f' /* for save search */,
  SELECT_LANDING_FORM_MESSAGING: 'vip-new.t' /* for messaging */,

  NO_LISTABLES: 'nl',

  /* ----------------------------------Favorites origin helper----------------------------------- */
  FAVORITES: {
    BUILDING: 'building',
    CAROUSEL: 'carousel',
    LISTING: 'listing',
  } as const,
  OPEN_HOUSE: 'L.v',
  /* ------------------------------------List----------------------------------------------------- */
  LIST_ITEM: 'f',
  LIST_ITEM_MESSAGED: 'msged',
  FILTER_PANEL: 'Filter Panel',
  FILTER_BAR: 'Filter Bar',

  /* ------------------------------------Homepage----------------------------------------------------- */
  HOMEPAGE: 'homepage',
  HOMEPAGE_ZUMPER_RENTALS: 'homepage-zumper-rentals',
  MOBILE_HOMEPAGE: 'm.homepage',
  HOMEPAGE_TOUR: 'homepage-tour',
  MOBILE_HOMEPAGE_TOUR: 'm.homepage-tour',

  NEAR_ME: 'nearme',

  /* ------------------------------------Onboarding----------------------------------------------------- */
  FILTER_ONBOARDING: 'Onboarding',

  /* ------------------------------------GalleryView----------------------------------------------------- */
  //	Mobile - Sticky button on image gallery, scrolling view
  GALLERY_MOBILE_STICKY: 'm.g-sticky-scroll',
  ADDR_GALLERY_MOBILE_STICKY: 'ad-m.g-sticky-scroll',
  // Mobile - Sticky button on image gallery, focus view
  GALLERY_MOBILE_FOCUSED: 'm.g-sticky-focus',
  ADDR_GALLERY_MOBILE_FOCUSED: 'ad-m.g-sticky-focus',
  // Mobile - Open lead form on image gallery, scrolling view
  GALLERY_MOBILE_LEAD_FORM: 'm.g-open-scroll',
  // Sticky button on image gallery, scrolling view
  GALLERY_STICKY: 'g-sticky-scroll',
  ADDR_GALLERY_STICKY: 'ad-g-sticky-scroll',
  // Sticky button on mage gallery, focus view
  GALLERY_FOCUSED: 'g-sticky-focus',
  ADDR_GALLERY_FOCUSED: 'ad-g-sticky-focus',
  // Mobile - Open lead form on image gallery, scrolling view
  GALLERY_LEAD_FORM: 'g-open-scroll',
  ADDR_GALLERY_LEAD_FORM: 'ad-g-open-scroll',
  // lead form on last slide of gallery carousel
  GALLERY_FOCUSED_LEAD_FORM: 'g-open-focus',
  ADDR_GALLERY_FOCUSED_LEAD_FORM: 'ad-g-open-focus',

  /* ------------------------------------Permanent Address Origins---------------------------------------------- */
  PA_TABLE: 'pa-table',
  ADDR_PA_TABLE: 'ad-pa-table',
  PA_TABLE_TOUR: 'pa-table-tour',
  ADDR_PA_TABLE_TOUR: 'ad-pa-table-tour',
  ADDRESS_FORM: 'pa-form',
  ADDR_ADDRESS_FORM: 'ad-pa-form', // used for address-on-building
  ADDRESS_MODAL_FORM: 'pa-modal-form',
  ADDRESS_UNIT_FORM: 'pa-unit-form',
  ADDR_ADDRESS_UNIT_FORM: 'ad-pa-unit-form', // used for address-on-building

  /* ------------------------------------Engrain---------------------------------------------- */
  ENGRAIN: 'engrain',

  /* ------------------------------------AI Assistant---------------------------------------------- */
  ZOE: 'zoe',
  /* ------------------------------------found in main app----------------------------------------- */
  EMAIL_OPT_IN: 'email-opt-in',
} as const

export type GalleryOrigins =
  | typeof Origin.GALLERY_FOCUSED
  | typeof Origin.ADDR_GALLERY_FOCUSED
  | typeof Origin.GALLERY_LEAD_FORM
  | typeof Origin.ADDR_GALLERY_LEAD_FORM
  | typeof Origin.GALLERY_FOCUSED_LEAD_FORM
  | typeof Origin.ADDR_GALLERY_FOCUSED_LEAD_FORM
  | typeof Origin.GALLERY_MOBILE_FOCUSED
  | typeof Origin.ADDR_GALLERY_MOBILE_FOCUSED
  | typeof Origin.GALLERY_MOBILE_LEAD_FORM
  | typeof Origin.GALLERY_MOBILE_STICKY
  | typeof Origin.ADDR_GALLERY_MOBILE_STICKY
  | typeof Origin.GALLERY_STICKY
  | typeof Origin.ADDR_GALLERY_STICKY

/* ------------------------------------Origin Groups---------------------------------------------- */
export const CAROUSEL_ORIGINS = [Origin.CAROUSEL_FROM_DETAIL] as const

export const LIST_ORIGINS = [
  Origin.LIST_ITEM,
  Origin.LIST_ITEM_MESSAGED,
  Origin.HOMEPAGE,
  Origin.HOMEPAGE_ZUMPER_RENTALS,
  Origin.NEAR_ME,
  Origin.NO_LISTABLES,
] as const

export const DETAIL_INLINE_ORIGINS = [
  Origin.DETAIL_INLINE,
  Origin.ADDR_DETAIL_INLINE,
  Origin.ADDR_DETAIL_INLINE,
  Origin.DETAIL_INLINE_BOTTOM,
  Origin.ADDR_DETAIL_INLINE_BOTTOM,
  Origin.DETAIL_INLINE_BUBBLE,
  Origin.DETAIL_INLINE_MODULE,
  Origin.ADDR_DETAIL_INLINE_MODULE,
  Origin.DETAIL_BOTTOM_SAVE_SEARCH,
] as const

export const DETAIL_STICKY_ORIGINS = [
  Origin.DETAIL_MOBILE_STICKY,
  Origin.ADDR_DETAIL_MOBILE_STICKY,
  Origin.DETAIL_MOBILE_STICKY_TOUR,
  Origin.ADDR_DETAIL_MOBILE_STICKY_TOUR,
  Origin.DETAIL_NAV_STICKY,
  Origin.ADDR_DETAIL_NAV_STICKY,
  Origin.DETAIL_NAV_STICKY_TOUR,
  Origin.ADDR_DETAIL_NAV_STICKY_TOUR,
] as const

export const FLOORPLAN_ORIGINS = [
  Origin.FLOORPLAN,
  Origin.FLOORPLAN_CARD,
  Origin.FLOORPLANS_UNIT_TOUR,
  Origin.FLOORPLANS_MODAL_UNIT_TOUR,
  Origin.FLOORPLANS_MODAL_TOP,
  Origin.ADDR_FLOORPLANS_MODAL_TOP,
  Origin.FLOORPLANS_MODAL_UNIT_TOP,
  Origin.ADDR_FLOORPLANS_MODAL_UNIT_TOP,
  Origin.MOBILE_FLOORPLAN,
] as const

/* ------------------------------------Formatted Origins---------------------------------------------- */
export const FormattedOrigin = {
  CAROUSEL: 'Carousel',
  DETAIL_AGENT: 'Detail Agent',
  DETAIL_INLINE: 'Detail In Line',
  DETAIL_STICKY: 'Detail Sticky',
  DETAIL_FLOORPLAN: 'Detail Floorplan',
  LIST: 'List Item',
  MAP: 'Map',
} as const
export type FormattedOrigin = (typeof FormattedOrigin)[keyof typeof FormattedOrigin]

export type OriginWithoutEctaSuffix =
  | typeof Origin.AFFORDABILITY_CALCULATOR
  | typeof Origin.AUTO
  | typeof Origin.FROM_EMAIL
  | typeof Origin.ADDR_FROM_EMAIL
  | typeof Origin.DETAIL_INLINE
  | typeof Origin.ADDR_DETAIL_INLINE
  | typeof Origin.DETAIL_TOP_RIGHT_RAIL
  | typeof Origin.ADDR_DETAIL_TOP_RIGHT_RAIL
  | typeof Origin.DETAIL_TOP_RIGHT_TOUR
  | typeof Origin.ADDR_DETAIL_TOP_RIGHT_TOUR
  | typeof Origin.DETAIL_NAV_STICKY
  | typeof Origin.ADDR_DETAIL_NAV_STICKY
  | typeof Origin.DETAIL_NAV_STICKY_TOUR
  | typeof Origin.ADDR_DETAIL_NAV_STICKY_TOUR
  | typeof Origin.DETAIL_INLINE_BOTTOM
  | typeof Origin.ADDR_DETAIL_INLINE_BOTTOM
  | typeof Origin.DETAIL_INLINE_BUBBLE
  | typeof Origin.DETAIL_MOBILE_BOTTOM
  | typeof Origin.ADDR_DETAIL_MOBILE_BOTTOM
  | typeof Origin.DETAIL_BOTTOM_TOUR
  | typeof Origin.DETAIL_MOBILE_STICKY
  | typeof Origin.ADDR_DETAIL_MOBILE_STICKY
  | typeof Origin.DETAIL_MOBILE_STICKY_TOUR
  | typeof Origin.ADDR_DETAIL_MOBILE_STICKY_TOUR
  | typeof Origin.DETAIL_MOBILE_BOTTOM_TOUR
  | typeof Origin.DETAIL_TOP_SAVE_SEARCH
  | typeof Origin.ADDR_DETAIL_TOP_SAVE_SEARCH
  | typeof Origin.DETAIL_INACTIVE
  | typeof Origin.DETAIL_MM_RELATED_PROPERTIES
  | typeof Origin.ADDR_DETAIL_MM_RELATED_PROPERTIES
  | typeof Origin.ADDRESS_MM_RELATED_PROPERTIES
  | typeof Origin.DETAIL_DESKTOP_MM_NEARBY_PROPERTIES
  | typeof Origin.ADDR_DETAIL_DESKTOP_MM_NEARBY_PROPERTIES
  | typeof Origin.DETAIL_INLINE_MODULE
  | typeof Origin.ADDR_DETAIL_INLINE_MODULE
  | typeof Origin.DETAIL_MOBILE_MM_NEARBY_PROPERTIES
  | typeof Origin.DETAIL_AGENT_BOX
  | typeof Origin.ADDR_DETAIL_AGENT_BOX
  | typeof Origin.DETAIL_QUESTION
  | typeof Origin.ADDR_DETAIL_QUESTION
  | typeof Origin.MOBILE_DETAIL_AGENT_BOX
  | typeof Origin.BUILDING
  | typeof Origin.LISTING
  | typeof Origin.RENT_RESEARCH
  | typeof Origin.ECTA_MESSAGE_SUFFIX
  | typeof Origin.ECTA_TOUR_SUFFIX
  | typeof Origin.ECTA_APPLY_SUFFIX
  | typeof Origin.DETAIL_HIGHLY_MESSAGED
  | typeof Origin.DETAIL_RESIDENT_INSIGHTS
  | typeof Origin.MOBILE_DETAIL_RESIDENT_INSIGHTS
  | typeof Origin.CAROUSEL_FROM_DETAIL
  | typeof Origin.ADDRESS_PAGE_INLINE_ALERT
  | typeof Origin.ADDR_ADDRESS_PAGE_INLINE_ALERT
  | typeof Origin.MAP
  | typeof Origin.LISTABLES
  | typeof Origin.DETAIL_MIDDLE_SAVE_SEARCH
  | typeof Origin.DETAIL_BOTTOM_SAVE_SEARCH
  | typeof Origin.SIMILAR
  | typeof Origin.SIMILAR_TOUR
  | typeof Origin.MONETIZED_SIMILAR
  | typeof Origin.FLOORPLAN
  | typeof Origin.FLOORPLANS_MODAL_TOP
  | typeof Origin.ADDR_FLOORPLANS_MODAL_TOP
  | typeof Origin.FLOORPLANS_MODAL_UNIT_TOP
  | typeof Origin.ADDR_FLOORPLANS_MODAL_UNIT_TOP
  | typeof Origin.FLOORPLANS_UNIT_TOUR
  | typeof Origin.FLOORPLANS_MODAL_UNIT_TOUR
  | typeof Origin.MOBILE_FLOORPLAN
  | `${typeof Origin.FLOORPLAN | typeof Origin.MOBILE_FLOORPLAN}-${typeof Origin.FLOORPLAN_CARD}${
      | ''
      | typeof Origin.MODAL_SUFFIX}`
  | typeof Origin.SELECT_LANDING_MESSAGE_MODAL
  | typeof Origin.SELECT_LANDING_FORM_ALERT
  | typeof Origin.SELECT_LANDING_FORM_MESSAGING
  | typeof Origin.NO_LISTABLES
  | typeof Origin.OPEN_HOUSE
  | typeof Origin.LIST_ITEM
  | typeof Origin.LIST_ITEM_MESSAGED
  | typeof Origin.FILTER_PANEL
  | typeof Origin.FILTER_BAR
  | typeof Origin.HOMEPAGE
  | typeof Origin.HOMEPAGE_ZUMPER_RENTALS
  | typeof Origin.MOBILE_HOMEPAGE
  | typeof Origin.HOMEPAGE_TOUR
  | typeof Origin.MOBILE_HOMEPAGE_TOUR
  | typeof Origin.NEAR_ME
  | typeof Origin.FILTER_ONBOARDING
  | typeof Origin.GALLERY_MOBILE_STICKY
  | typeof Origin.ADDR_GALLERY_MOBILE_STICKY
  | typeof Origin.GALLERY_MOBILE_FOCUSED
  | typeof Origin.ADDR_GALLERY_MOBILE_FOCUSED
  | typeof Origin.GALLERY_MOBILE_LEAD_FORM
  | typeof Origin.GALLERY_STICKY
  | typeof Origin.ADDR_GALLERY_STICKY
  | typeof Origin.GALLERY_FOCUSED
  | typeof Origin.ADDR_GALLERY_FOCUSED
  | typeof Origin.GALLERY_LEAD_FORM
  | typeof Origin.ADDR_GALLERY_LEAD_FORM
  | typeof Origin.GALLERY_FOCUSED_LEAD_FORM
  | typeof Origin.ADDR_GALLERY_FOCUSED_LEAD_FORM
  | typeof Origin.PA_TABLE
  | typeof Origin.ADDR_PA_TABLE
  | typeof Origin.PA_TABLE_TOUR
  | typeof Origin.ADDR_PA_TABLE_TOUR
  | typeof Origin.ADDRESS_FORM
  | typeof Origin.ADDR_ADDRESS_FORM
  | typeof Origin.ADDRESS_MODAL_FORM
  | typeof Origin.ADDRESS_UNIT_FORM
  | typeof Origin.ADDR_ADDRESS_UNIT_FORM
  | typeof Origin.ENGRAIN
  | typeof Origin.RENT_RESEARCH_MOBILE
  | typeof Origin.RENT_RESEARCH_TOUR
  | typeof Origin.RENT_RESEARCH_TOUR_MOBILE
  | typeof Origin.ZOE
  | typeof Origin.EMAIL_OPT_IN

type _Origin =
  | OriginWithoutEctaSuffix
  | `${OriginWithoutEctaSuffix | ''}${
      | typeof Origin.ECTA_APPLY_SUFFIX
      | typeof Origin.ECTA_MESSAGE_SUFFIX
      | typeof Origin.ECTA_TOUR_SUFFIX}`

export type NonMultiMessageOrigin = Exclude<_Origin, `${string}-mm` | `${string}-mm-${string}`>

export type Origin = _Origin | `${NonMultiMessageOrigin}-mm`

export function isNotMultiMessageOrigin(origin: Origin): origin is NonMultiMessageOrigin {
  return !origin.match(/-mm\b/)
}
